// 接口引入
import {
  FuzzySearch,
} from '@/api/purchaseAndSaleAPI'
import { maintenanceList } from '@/api/serviceAPi'
import { providerList } from '@/api/company'
import selectOption from '@/store/dict/selectOptionDict'
import { CAR_MODEL_FILTER_SCENE } from '@/config/carManage'

export default function (data) {
  const { dealWithData } = data
  const oLoading = {
    fuzzy: false,
    search: false,
  }
  // 车牌号模糊搜索
  const remoteMethod = async (query) => {
    if (query.length >= 4) {
      // 开启远程搜索
      oLoading.fuzzy = true
      // eslint-disable-next-line no-shadow
      const { code, data } = await FuzzySearch({
        state: 1,
        plateNo: query,
      })
      oLoading.fuzzy = false
      if (code === 1) {
        // 关闭远程搜索
        oLoading.fuzzy = true
        this.$refs.baseListManagement.setItemData({ elConfigKey: 'list', key: 'carId', data })
        // this.carOptions = data
      } else {
        this.$refs.baseListManagement.setItemData({ elConfigKey: 'list', key: 'carId', data: [] })
      }
    } else {
      this.$refs.baseListManagement.setItemData({ elConfigKey: 'list', key: 'carId', data: [] })
    }
  }

  /* 获取修理厂名单 */
  const getProvider = async () => {
    const res = await providerList({
      serviceType: 1,
      state: 1,
    })
    // eslint-disable-next-line no-shadow
    const { code, data } = res
    if (code === 1) {
      this.$refs.baseListManagement.setItemData({ elConfigKey: 'list', key: 'providerId', data: [{ name: '全部', id: '' }, ...data.items] })
    } else {
      this.$refs.baseListManagement.setItemData({ elConfigKey: 'list', key: 'providerId', data: [] })
    }
  }

  // 维修厂集合
  getProvider()

  // 下拉框出现/隐藏
  const changeValue = (e, str) => {
    if (!e) {
      this.$refs.baseListManagement.setItemData({ elConfigKey: 'list', key: str, data: [] })
    }
  }

  // 处理搜索数据
  const dealWithSearch = (params) => {
    if (dealWithData)dealWithData(params)
    // 时间处理
    // 送厂时间
    if (params.value1 && params.value1.length > 0) {
      params.incomeTimeBegin = params.value1[0]
      params.incomeTimeEnd = params.value1[1]
    } else {
      delete params.incomeTimeBegin
      delete params.incomeTimeEnd
      delete params.value1
    }
    const { brandSeriesModel } = params
    params.brandId = brandSeriesModel.brandId
    params.seriesId = brandSeriesModel.seriesId
    params.modelId = brandSeriesModel.modelId
    delete params.brandSeriesModel
    return params
  }

  const configData = {
    formData: {
      list: [
        {
          el: 'input',
          itemConfig: {
            label: '维保单ID',
            prop: 'id',
          },
          directives: [{ name: 'number', arg: 'integer', value: 18 }],
        },
        {
          el: 'select',
          itemConfig: {
            label: '车牌号',
            prop: 'carId',
          },
          elConfig: {
            filterable: true,
            remote: true,
            'reserve-keyword': true,
            placeholder: '请输入',
            'remote-method': remoteMethod,
            events: {
              'visible-change': (e) => {
                changeValue(e, 'carId')
              },
            },
            options: {
              label: 'plateNo',
              value: 'id',
              list: [],
            },
          },
        },
        {
          itemConfig: {
            prop: 'brandSeriesModel',
          },
          elConfig: {
            showModel: true,
            filterScene: CAR_MODEL_FILTER_SCENE.IN_STOCK,
          },
          render: 'CarBrandSeriesModel',
        },
        {
          el: 'select',
          itemConfig: {
            label: '维修厂',
            prop: 'providerId',
          },
          elConfig: {
            placeholder: '请选择维修厂',
            options: {
              label: 'name',
              value: 'id',
              list: [],
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '维保状态',
            prop: 'maintenanceState',
          },
          elConfig: {
            placeholder: '全部',
            options: {
              label: 'label',
              value: 'value',
              list: this.dictParseList(selectOption.maintenanceStateDict, true),
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '结算状态',
            prop: 'settlementState',
          },
          elConfig: {
            placeholder: '全部',
            options: {
              label: 'label',
              value: 'value',
              list: this.dictParseList(selectOption.settlementStatusDict, true),
            },
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '维保类型',
            prop: 'type',
          },
          elConfig: {
            placeholder: '全部',
            options: {
              label: 'label',
              value: 'value',
              list: this.dictParseList(selectOption.maintenanceTypeDict, true),
            },
          },
        },
        {
          el: 'date-picker',
          itemConfig: {
            label: '送厂时间',
            prop: 'value1',
          },
        },
        {
          el: 'select',
          itemConfig: {
            label: '来源类型',
            prop: 'sourceType',
          },
          elConfig: {
            placeholder: '请选择来源类型',
            options: {
              label: 'label',
              value: 'value',
              list: this.dictParseList(selectOption.maintenanceSourceDict, true),
            },
          },
        },
      ],
      dealWithSearch,
      customizeReset: () => {
        this.$refs.baseListManagement.setItemData({
          elConfigKey: 'value',
          key: 'brandSeriesModel',
          data: {},
        })
      },
    },
    tableData: {
      columns: [
        {
          name: 'id',
          columnProps: {
            prop: 'id',
            label: '维保单ID',
            width: 120,
          },
          // type: 'manual'
        },
        {
          name: 'plateNo',
          columnProps: {
            prop: 'plateNo',
            label: '车牌号',
            width: 100,
          },
          showColumnItem: !this.isCarDetail,
        },
        {
          name: 'brandName',
          columnProps: {
            prop: 'brandName',
            label: '品牌',
            showOverflowTooltip: true,
            limitEllipsisLine: 1,
            width: 160,
          },
          showColumnItem: !this.isCarDetail,
        },
        {
          name: 'seriesName',
          columnProps: {
            prop: 'seriesName',
            label: '车系',
            showOverflowTooltip: true,
            limitEllipsisLine: 1,
            width: 160,
          },
          showColumnItem: !this.isCarDetail,
        },
        {
          name: 'modelName',
          columnProps: {
            prop: 'modelName',
            label: '车型',
            showOverflowTooltip: true,
            limitEllipsisLine: 1,
            width: 160,
          },
          showColumnItem: !this.isCarDetail,

        },
        {
          name: 'providerName',
          columnProps: {
            prop: 'providerName',
            label: '维修厂',
            showOverflowTooltip: true,
          },
        },
        {
          name: 'type',
          columnProps: {
            prop: 'type',
            label: '维保类型',
            width: 100,
          },
          getText: ({ row }) => selectOption.maintenanceTypeDict[row.type],
        },
        {
          name: 'totalAmount',
          columnProps: {
            prop: 'totalAmount',
            label: '维保费用(元)',
            width: 120,
          },
          getText: ({ row }) => this.numberWithCommas(row.totalAmount),
        },
        {
          name: 'expenseBearingPartyValue',
          columnProps: {
            prop: 'expenseBearingPartyValue',
            label: '费用承担方',
            width: 150,
          },
          showEllipsisTooltip: true,
          limitEllipsisLine: 1,
        },
        {
          name: 'sourceType',
          columnProps: {
            prop: 'sourceType',
            label: '来源类型',
          },
          getText: ({ row }) => selectOption.maintenanceSourceDict[row.sourceType],
        },
        {
          name: 'incomeTime',
          columnProps: {
            prop: 'incomeTime',
            label: '送厂时间',
            width: 100,
          },
        },
        {
          name: 'maintenanceState',
          columnProps: {
            prop: 'maintenanceState',
            label: '维保状态',
            width: 135,
          },
          getText: ({ row }) => selectOption.maintenanceStateDict[row.maintenanceState],
        },
        {
          name: 'settlementState',
          columnProps: {
            prop: 'settlementState',
            label: '结算状态',
          },
          getText: ({ row }) => selectOption.settlementStatusDict[row.settlementState],
        },
      ],
      apiFn: maintenanceList,
    },
  }

  return {
    configData,
  }
}
